var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.getcurrent
    ? _c(
        "div",
        { attrs: { id: "versand" } },
        [
          _vm.getcurrent.prices.default.vat.value === 0
            ? [
                _c("div", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$translate("Klettershop5::Template.singleVatFree")
                    )
                  }
                })
              ]
            : [
                _c(
                  "span",
                  [
                    _vm._v("\n              *"),
                    _vm.shownetprices
                      ? [
                          _vm._v(
                            "\n                      " +
                              _vm._s(
                                _vm.$translate(
                                  "Ceres::Template.singleItemExclVAT"
                                )
                              ) +
                              "\n              "
                          )
                        ]
                      : [
                          _vm._v(
                            "\n                  " +
                              _vm._s(
                                _vm.$translate(
                                  "Ceres::Template.singleItemInclVAT"
                                )
                              ) +
                              "\n              "
                          )
                        ],
                    _vm._v(
                      "\n              " +
                        _vm._s(
                          _vm.$translate("Ceres::Template.singleItemExclusive")
                        )
                    ),
                    _c("a", { attrs: { href: _vm.url, target: "_blank" } }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$translate(
                              "Ceres::Template.singleItemShippingCosts"
                            )
                          )
                      )
                    ])
                  ],
                  2
                )
              ]
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }